export enum AlertType {
    Success ='success',
    Error='danger',
    Info='info',
    Warning='warning'
}